import { graphql } from "~/gql";

export const FIND_CUMULATIVE_ACCRUED_FEES_FOR_EXTERNAL_MATTER = graphql(/* GraphQL */ `
  query FindCumulativeAccruedFeesForExternalMatter($externalMatterId: Float!) {
    findCumulativeAccruedFeesForExternalMatter(externalMatterId: $externalMatterId) {
      date
      amount
    }
  }
`);
